import { render, staticRenderFns } from "./CreateButton.vue?vue&type=template&id=02052a60&scoped=true"
import script from "./CreateButton.vue?vue&type=script&lang=js"
export * from "./CreateButton.vue?vue&type=script&lang=js"
import style0 from "./CreateButton.vue?vue&type=style&index=0&id=02052a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02052a60",
  null
  
)

export default component.exports